import { CommunicationMethod } from "./siteFuelPointDTO";

export interface SitePeripheralDTO {
  code?: string;
  peripheralNumber: number;
  serialNumber?: string;
  siteCode: string;
  description: string;
  detailedDescription?: object;
  enabled: boolean;
  peripheralTypeCode?: string;
  protocolTypeCode: string;
  communicationMethodTypeCode: string;
  communicationMethodData: CommunicationMethod;
  additionalData?: object;
}

export interface PeripheralTypeDTO {
  code: string;
  description: string;
  detailedDescription?: object;
}

export enum PeripheralType {
  PRINTER = "PRINTER",
  CLIENT_DISPLAY = "CLIENT_DISPLAY",
  BARCODE_SCANNER = "BARCODE_SCANNER",
  CARD_READER = "CARD_READER",
}
